module.exports = __webpack_public_path__ + "img/img3.a638efe9.png";